import { AsyncThunk, createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { API } from '../../API/API';
import { IGetMe } from '../../Interfaces/responseTypes';

interface IinitialState {
  currentUser: IGetMe | {};
  isLoading: boolean;
  error: string | null;
}

const initialState: IinitialState = {
  currentUser: {},
  isLoading: false,
  error: null,
};

export const getMe: AsyncThunk<IGetMe, void, any> = createAsyncThunk('currentUser', async () => {
  const response: any = await API.get('/api/get_me/', {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('p_menu_token')}`,
    },
  });
  return response.data;
});

const authSlice = createSlice({
  name: 'calculate',
  initialState,
  reducers: {
    removeCurrentUser(state) {
      state.currentUser = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getMe.fulfilled, (state, action: PayloadAction<IGetMe>) => {
        state.currentUser = action.payload;
        state.isLoading = false;
        state.error = null; 
      })
      .addCase(getMe.pending, (state) => {
        state.isLoading = true;
        state.error = null; 
      })
      .addCase(getMe.rejected, (state, action) => {
        state.isLoading = false;
        state.error = (action.error as Error)?.message || 'Failed to fetch user data';
      });
  },
});

export const { removeCurrentUser } = authSlice.actions;
export default authSlice.reducer;
